import Logger from "@/utility/logger";

// A comment the server already wrote into a downloaded report (or an earlier
// pass) starts with this text. Its author is the requesting user or "Jenly", so
// the text is what identifies it.
const JENLY_COMMENT_TEXT = /^\s*jenly\.ai:/i;

export type ExistingComments = Word.CommentCollection | null;

// Loads the comments already attached to each range, so a placeholder that
// already has its Jenly comment is not given a second one. When the host cannot
// report comments, ranges are treated as uncommented.
export const loadExistingComments = async (
  context: Word.RequestContext,
  ranges: Word.Range[]
): Promise<ExistingComments[]> => {
  try {
    const collections = ranges.map((range) => {
      const comments = range.getComments();
      comments.load("items/content");
      return comments;
    });
    await context.sync();
    return collections;
  } catch (error) {
    Logger.warn("wordExistingComments.ts: Existing comments could not be read; assuming none.", error);
    return ranges.map(() => null);
  }
};

export const hasJenlyComment = (comments: ExistingComments): boolean =>
  Boolean(comments?.items?.some((comment) => JENLY_COMMENT_TEXT.test(comment.content || "")));
